import { useAppSelector } from '../redux/hooks';
import { EDITING_FROZEN_ORG_IDS } from '../utils/constants';

/**
 * Reads the org-level `editingFrozen` flag (BE: organization.flags.editingFrozen).
 *
 * While an org is frozen (relaunch clean-up, B4-2) every admin program-editing
 * surface renders read-only and the write endpoints answer 423. RDP Creative is
 * force-frozen through the FE allowlist so the freeze holds before the BE flag
 * is flipped. Learner pages are not affected.
 */
const useEditingFrozen = (): boolean => {
  return useAppSelector((state) => {
    const org = state.orgDetails.data as
      | { authId?: string; flags?: { editingFrozen?: boolean } }
      | undefined;
    if (org?.flags?.editingFrozen === true) return true;
    return Boolean(org?.authId && EDITING_FROZEN_ORG_IDS.includes(org.authId));
  });
};

export default useEditingFrozen;
